export default "__VITE_ASSET__DVvFRmSy__"